import { createRoutine } from 'redux-saga-routines';

export const fetchTicketsByEntity = createRoutine('FETCH_TICKET');

export const fetchTicketsSummary = createRoutine('FETCH_TICKETS_SUMMARY');
export const fetchAllTickets = createRoutine('FETCH_ALL_TICKET');
export const fetchTicketById = createRoutine('FETCH_TICKET_BY_ID');
export const fetchTicketUpdatesAndComments = createRoutine(
  'FETCH_UPDATES_COMMENTS_BY_ID'
);
export const fetchTicketFiles = createRoutine('FETCH_TICKET_FILES');
export const loadMoreTicketsByEntity = createRoutine('LOAD_MORE_TICKETS');
export const clearTickets = createRoutine('CLEAR_TICKETS');
